import { Flex, Table, Group, ActionIcon } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { YesNoDialog } from "components/YesNoDialog";
import { useState } from "react";
import { useAppTranslation } from "../../hooks/useTranslation";

interface OrganizersListProps {
  organizers: any[];
  onOrganizerChosen: (uid: string) => void;
  onOrganizerDelete: (uid: string) => void;
}

export const OrganizersList = (props: OrganizersListProps) => {
  const { organizers, onOrganizerChosen, onOrganizerDelete } = props;
  const { t } = useAppTranslation();

  const [opened, { open, close }] = useDisclosure(false);
  const [deletedUid, setDeletedUid] = useState("");

  const deleteOrganizerDialog = (uid: string) => {
    setDeletedUid(uid);
    open();
  };

  const deleteOrganizer = () => {
    onOrganizerDelete(deletedUid);
  };

  return (
    <>
      <Flex direction="column" justify="space-between">
        <Table
          horizontalSpacing="md"
          verticalSpacing="xs"
          miw={700}
          highlightOnHover
          layout="fixed"
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("organizers.name")}</Table.Th>
              <Table.Th>{t("organizers.email")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {organizers.map((organizer) => {
              const onOrganizerClicked = () => {
                onOrganizerChosen(organizer.uid);
              };
              return (
                <Table.Tr key={organizer.uid}>
                  <Table.Td onClick={onOrganizerClicked}>
                    {organizer.name}
                  </Table.Td>
                  <Table.Td onClick={onOrganizerClicked}>
                    {organizer.email}
                  </Table.Td>
                  <Table.Td>
                    <Group>
                      <ActionIcon onClick={onOrganizerClicked}>
                        <IconEdit />
                      </ActionIcon>
                      <ActionIcon
                        style={{ zIndex: 10 }}
                        onClick={() => {
                          deleteOrganizerDialog(organizer.uid);
                        }}
                      >
                        <IconTrash />
                      </ActionIcon>
                    </Group>
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Flex>
      <YesNoDialog
        opened={opened}
        title={t("common.delete") + " " + t("organizers.title").slice(0, -1)}
        question={t("organizers.delete_confirmation")}
        onClose={close}
        onYes={deleteOrganizer}
      />
    </>
  );
};
